@if (headerLoading) {
  <ebs-spinner class="px-3 py-1" [spinnerMessage]="'loading your application...'" [faColour]="'#0A3E65'"
  [boxColour]="'#0A3E65'" [boxPadding]="'5px 15px'"></ebs-spinner>
}


@if (!headerLoading) {
  <header class="portal-header">
    <div class="ebs-navbar">
      <nav class="navbar" role="navigation" aria-label="main navigation">
        @if (isTheLoginScreen) {
          <div class="navbar-brand" style="display: flex !important;" >
            <a [routerLink]="[ '/', 'dashboard' ]" class="logo" >
              @if (showPrimaryHeaderLogo) {
                <img src="{{primaryHeaderLogoSrc}}" alt="Primary Course Logo">
              }
            </a>
          </div>
        }
        @if (!isTheLoginScreen) {
          <div class="navbar-brand">
            <a [routerLink]="[ '/', 'dashboard' ]" class="logo" >
              @if (showPrimaryHeaderLogo) {
                <img src="{{primaryHeaderLogoSrc}}" alt="Primary Course Logo" [ngClass]="showSecondaryHeaderLogo ? 'scale-logo' : ''">
              }
              @if (showSecondaryHeaderLogo) {
                <img src="{{secondaryHeaderLogoSrc}}" alt="Secondary Course Logo" class="secondary-course-logo scale-logo">
              }
            </a>
          </div>
        }
        <div class="navbar-menu">
          <div class="navbar-end">
            <ebs-top-menu [avatar]="avatar" [isWorkingOffline]="isWorkingOffline"
              [noInternetConnection]="noInternetConnection" [displayMenu]="displayMenu"
              [displayOfflineMenu]="displayOfflineMenu" [isOffline]="isOffline">
            </ebs-top-menu>
          </div>
        </div>
      </nav>
    </div>
  </header>
}